export interface SeasonalDestination {
  countries: string[];
  regions: string[];
  reason: string;
  temperature: string;
}

export interface MonthlyRecommendations {
  [month: string]: {
    warm: SeasonalDestination;
    moderate: SeasonalDestination;
    cold: SeasonalDestination;
    special: SeasonalDestination[];
  };
}

export const SEASONAL_RECOMMENDATIONS: MonthlyRecommendations = {
  'januari': {
    warm: {
      countries: ['Thailand', 'Verenigde Arabische Emiraten', 'Egypte', 'Filipijnen', 'Maleisië'],
      regions: ['Dubai', 'Abu Dhabi', 'Bangkok', 'Phuket', 'Hurghada', 'Sharm el Sheikh'],
      reason: 'Tropisch warm weer (25-30°C)',
      temperature: '25-30°C'
    },
    moderate: {
      countries: ['Canarische Eilanden', 'Madeira'],
      regions: ['Tenerife', 'Gran Canaria', 'Lanzarote', 'Fuerteventura'],
      reason: 'Mild winterklimaat (18-22°C)',
      temperature: '18-22°C'
    },
    cold: {
      countries: ['Oostenrijk', 'Frankrijk', 'Zwitserland', 'Italië'],
      regions: ['Tirol', 'Alpen', 'Dolomiten'],
      reason: 'Perfecte wintersport condities',
      temperature: '-5 tot 5°C'
    },
    special: [{
      countries: ['Japan'],
      regions: ['Tokyo', 'Kyoto'],
      reason: 'Droog winterweer, minder toeristen',
      temperature: '5-10°C'
    }]
  },
  'februari': {
    warm: {
      countries: ['Thailand', 'Verenigde Arabische Emiraten', 'Vietnam', 'Cambodja'],
      regions: ['Dubai', 'Phuket', 'Ho Chi Minh', 'Siem Reap'],
      reason: 'Droog seizoen in Azië',
      temperature: '25-30°C'
    },
    moderate: {
      countries: ['Canarische Eilanden', 'Madeira'],
      regions: ['Tenerife', 'Gran Canaria'],
      reason: 'Lenteweer op de eilanden',
      temperature: '18-22°C'
    },
    cold: {
      countries: ['Oostenrijk', 'Frankrijk', 'Zwitserland'],
      regions: ['Tirol', 'Alpen'],
      reason: 'Top wintersport maand',
      temperature: '-5 tot 5°C'
    },
    special: []
  },
  'maart': {
    warm: {
      countries: ['Egypte', 'Jordanië', 'Verenigde Arabische Emiraten'],
      regions: ['Hurghada', 'Sharm el Sheikh', 'Dubai', 'Petra'],
      reason: 'Perfect weer in het Midden-Oosten',
      temperature: '22-28°C'
    },
    moderate: {
      countries: ['Marokko', 'Tunesië', 'Cyprus'],
      regions: ['Marrakech', 'Tunis', 'Paphos'],
      reason: 'Lente in Noord-Afrika',
      temperature: '18-24°C'
    },
    cold: {
      countries: ['Oostenrijk', 'Frankrijk'],
      regions: ['Tirol', 'Alpen'],
      reason: 'Laatste wintersport weken',
      temperature: '0-10°C'
    },
    special: []
  },
  'april': {
    warm: {
      countries: ['Egypte', 'Turkije', 'Cyprus', 'Marokko'],
      regions: ['Hurghada', 'Antalya', 'Side', 'Paphos', 'Marrakech'],
      reason: 'Perfecte temperaturen zonder hitte',
      temperature: '20-26°C'
    },
    moderate: {
      countries: ['Griekenland', 'Spanje', 'Portugal'],
      regions: ['Kreta', 'Andalusië', 'Algarve'],
      reason: 'Lenteweer in Zuid-Europa',
      temperature: '16-22°C'
    },
    cold: {
      countries: ['Nederland', 'Duitsland', 'België'],
      regions: ['Amsterdam', 'Berlijn', 'Brussel'],
      reason: 'Bloeiende lente in West-Europa',
      temperature: '10-16°C'
    },
    special: []
  },
  'mei': {
    warm: {
      countries: ['Turkije', 'Cyprus', 'Egypte', 'Tunesië'],
      regions: ['Antalya', 'Side', 'Paphos', 'Hurghada', 'Hammamet'],
      reason: 'Ideaal strandweer begint',
      temperature: '22-28°C'
    },
    moderate: {
      countries: ['Griekenland', 'Spanje', 'Portugal', 'Italië'],
      regions: ['Kreta', 'Kos', 'Costa Brava', 'Algarve', 'Toscane'],
      reason: 'Perfect weer in Zuid-Europa',
      temperature: '18-25°C'
    },
    cold: {
      countries: ['Scandinavië'],
      regions: ['Stockholm', 'Oslo', 'Kopenhagen'],
      reason: 'Witte nachten seizoen begint',
      temperature: '12-18°C'
    },
    special: []
  },
  'juni': {
    warm: {
      countries: ['Turkije', 'Griekenland', 'Cyprus', 'Spanje'],
      regions: ['Antalya', 'Kreta', 'Kos', 'Paphos', 'Balearen'],
      reason: 'Hoogseizoen begint',
      temperature: '25-30°C'
    },
    moderate: {
      countries: ['Portugal', 'Italië', 'Frankrijk'],
      regions: ['Algarve', 'Toscane', 'Provence', 'Côte d\'Azur'],
      reason: 'Perfecte zomertemperaturen',
      temperature: '20-26°C'
    },
    cold: {
      countries: ['Scandinavië', 'IJsland'],
      regions: ['Stockholm', 'Reykjavik'],
      reason: 'Lupine bloei en witte nachten',
      temperature: '15-20°C'
    },
    special: []
  },
  'juli': {
    warm: {
      countries: ['Griekenland', 'Turkije', 'Spanje', 'Cyprus'],
      regions: ['Griekse eilanden', 'Turkse Riviera', 'Balearen', 'Canarische Eilanden'],
      reason: 'Topseizoen mediterrane zomer',
      temperature: '28-35°C'
    },
    moderate: {
      countries: ['Portugal', 'Frankrijk', 'Kroatië'],
      regions: ['Noord-Portugal', 'Bretagne', 'Dalmatië'],
      reason: 'Zomer zonder extreme hitte',
      temperature: '22-28°C'
    },
    cold: {
      countries: ['Scandinavië', 'Schotland'],
      regions: ['Noorwegen', 'Schotse Hooglanden'],
      reason: 'Warmste maand in het noorden',
      temperature: '15-22°C'
    },
    special: []
  },
  'augustus': {
    warm: {
      countries: ['Griekenland', 'Turkije', 'Spanje', 'Italië'],
      regions: ['Griekse eilanden', 'Turkse Riviera', 'Sicilië', 'Sardinië'],
      reason: 'Heetste zomermaand',
      temperature: '28-38°C'
    },
    moderate: {
      countries: ['Portugal', 'Noord-Frankrijk', 'Roemenië'],
      regions: ['Noord-Portugal', 'Normandië', 'Transsylvanië'],
      reason: 'Warme zomer, minder druk',
      temperature: '22-28°C'
    },
    cold: {
      countries: ['Scandinavië', 'Baltische Staten'],
      regions: ['Finland', 'Estland', 'Letland'],
      reason: 'Korte maar warme zomer',
      temperature: '15-22°C'
    },
    special: []
  },
  'september': {
    warm: {
      countries: ['Turkije', 'Egypte', 'Cyprus', 'Griekenland'],
      regions: ['Antalya', 'Hurghada', 'Paphos', 'Kreta'],
      reason: 'Nazomer, minder druk',
      temperature: '25-30°C'
    },
    moderate: {
      countries: ['Spanje', 'Portugal', 'Italië', 'Kroatië'],
      regions: ['Andalusië', 'Algarve', 'Toscane', 'Dalmatië'],
      reason: 'Perfecte nazomertemperaturen',
      temperature: '20-26°C'
    },
    cold: {
      countries: ['Duitsland', 'Oostenrijk', 'Tsjechië'],
      regions: ['Beieren', 'Salzburg', 'Praag'],
      reason: 'Prachtige herfstkleur',
      temperature: '12-18°C'
    },
    special: []
  },
  'oktober': {
    warm: {
      countries: ['Egypte', 'Turkije', 'Cyprus', 'Canarische Eilanden'],
      regions: ['Hurghada', 'Antalya', 'Paphos', 'Tenerife'],
      reason: 'Nazomer zonder hitte',
      temperature: '22-28°C'
    },
    moderate: {
      countries: ['Marokko', 'Tunesië', 'Portugal'],
      regions: ['Marrakech', 'Hammamet', 'Algarve'],
      reason: 'Perfecte herfsttemperaturen',
      temperature: '18-24°C'
    },
    cold: {
      countries: ['Duitsland', 'Frankrijk', 'Italië'],
      regions: ['Rijnland', 'Bourgogne', 'Toscane'],
      reason: 'Prachtige herfstsfeer',
      temperature: '10-16°C'
    },
    special: []
  },
  'november': {
    warm: {
      countries: ['Egypte', 'Verenigde Arabische Emiraten', 'Canarische Eilanden', 'Thailand'],
      regions: ['Hurghada', 'Dubai', 'Tenerife', 'Bangkok'],
      reason: 'Ontsnap aan de Nederlandse winter',
      temperature: '22-28°C'
    },
    moderate: {
      countries: ['Marokko', 'Tunesië', 'Cyprus'],
      regions: ['Marrakech', 'Hammamet', 'Paphos'],
      reason: 'Mild weer in Noord-Afrika',
      temperature: '16-22°C'
    },
    cold: {
      countries: ['Nederland', 'België', 'Duitsland'],
      regions: ['Amsterdam', 'Brussel', 'Keulen'],
      reason: 'Gezellige winterse stedentrips',
      temperature: '5-12°C'
    },
    special: []
  },
  'december': {
    warm: {
      countries: ['Thailand', 'Verenigde Arabische Emiraten', 'Egypte', 'Canarische Eilanden'],
      regions: ['Phuket', 'Dubai', 'Hurghada', 'Tenerife'],
      reason: 'Tropische winterescape',
      temperature: '22-30°C'
    },
    moderate: {
      countries: ['Canarische Eilanden', 'Madeira'],
      regions: ['Gran Canaria', 'Lanzarote', 'Funchal'],
      reason: 'Zacht winterklimaat',
      temperature: '16-22°C'
    },
    cold: {
      countries: ['Oostenrijk', 'Frankrijk', 'Zwitserland'],
      regions: ['Tirol', 'Alpen', 'Graubünden'],
      reason: 'Kerstmis in de sneeuw',
      temperature: '-5 tot 5°C'
    },
    special: [{
      countries: ['Duitsland', 'Oostenrijk', 'België'],
      regions: ['Keulen', 'Salzburg', 'Brussel'],
      reason: 'Magische kerstmarkten',
      temperature: '0-8°C'
    }]
  }
};

export const WEATHER_KEYWORDS = {
  warm: ['zon', 'warm', 'warmte', 'zonnig', 'hitte', 'strand', 'zee', 'zwemmen'],
  cold: ['koud', 'sneeuw', 'winter', 'ski', 'bergen', 'wintersport'],
  moderate: ['mild', 'aangenaam', 'lente', 'herfst']
};

export const ACTIVITY_KEYWORDS = {
  beach: ['strand', 'zee', 'zwemmen', 'zonnen', 'duiken', 'snorkelen'],
  culture: ['cultuur', 'museum', 'geschiedenis', 'kunst', 'stad', 'stedentrip'],
  nature: ['natuur', 'wandelen', 'bergen', 'bos', 'wildlife'],
  winter: ['ski', 'snowboard', 'wintersport', 'sneeuw', 'après-ski'],
  relaxation: ['ontspanning', 'wellness', 'spa', 'rust', 'rustig']
};

export const detectSeasonalIntent = (query: string) => {
  const lowerQuery = query.toLowerCase();
  
  // Month detection
  const months = {
    'januari': 'januari',
    'februari': 'februari', 
    'maart': 'maart',
    'april': 'april',
    'mei': 'mei',
    'juni': 'juni',
    'juli': 'juli',
    'augustus': 'augustus',
    'september': 'september',
    'oktober': 'oktober',
    'november': 'november',
    'december': 'december'
  };
  
  let detectedMonth = null;
  for (const [dutch, standard] of Object.entries(months)) {
    if (lowerQuery.includes(dutch)) {
      detectedMonth = standard;
      break;
    }
  }
  
  // Weather preference detection
  const warmKeywords = ['zon', 'zonnig', 'warm', 'warme', 'tropisch', 'strand', 'zee'];
  const coldKeywords = ['koud', 'winter', 'sneeuw', 'ski', 'wintersport'];
  
  let weatherPreference = null;
  if (warmKeywords.some(keyword => lowerQuery.includes(keyword))) {
    weatherPreference = 'warm';
  } else if (coldKeywords.some(keyword => lowerQuery.includes(keyword))) {
    weatherPreference = 'cold';
  }
  
  // Geographic restrictions detection
  const geographicRestrictions = [];
  if (lowerQuery.includes('buiten europa') || lowerQuery.includes('niet europa') || lowerQuery.includes('outside europe')) {
    geographicRestrictions.push('outside_europe');
  }
  if (lowerQuery.includes('in europa') || lowerQuery.includes('europa') && !lowerQuery.includes('buiten europa')) {
    geographicRestrictions.push('europe_only');
  }
  if (lowerQuery.includes('verre reis') || lowerQuery.includes('ver weg') || lowerQuery.includes('intercontinentaal')) {
    geographicRestrictions.push('long_haul');
  }
  
  // Activity detection
  const activities = [];
  if (lowerQuery.includes('strand') || lowerQuery.includes('beach') || lowerQuery.includes('zee')) {
    activities.push('beach');
  }
  if (lowerQuery.includes('ski') || lowerQuery.includes('wintersport')) {
    activities.push('winter');
  }
  if (lowerQuery.includes('cultuur') || lowerQuery.includes('museum') || lowerQuery.includes('stad')) {
    activities.push('culture');
  }
  
  const isSeasonalQuery = detectedMonth !== null || weatherPreference !== null;
  
  return {
    month: detectedMonth,
    weatherPreference,
    geographicRestrictions,
    activities,
    isSeasonalQuery
  };
};

export const getSeasonalRecommendations = (month: string, weatherPreference: string, activities: string[] = [], geographicRestrictions: string[] = []) => {
  const monthIndex = {
    'januari': 1, 'februari': 2, 'maart': 3, 'april': 4, 'mei': 5, 'juni': 6,
    'juli': 7, 'augustus': 8, 'september': 9, 'oktober': 10, 'november': 11, 'december': 12
  }[month.toLowerCase()];
  
  if (!monthIndex) return null;
  
  // Define European countries
  const europeanCountries = [
    'Spanje', 'Frankrijk', 'Italië', 'Griekenland', 'Portugal', 'Kroatië', 
    'Cyprus', 'Malta', 'Duitsland', 'Oostenrijk', 'Nederland', 'België', 
    'Bulgarije', 'Roemenië', 'Slovenië', 'Tsjechië', 'Polen', 'Hongarije',
    'Turkije' // Often considered part of Europe in travel context
  ];
  
  let recommendations = { countries: [], regions: [], reason: '', temperature: '' };
  
  if (weatherPreference === 'warm') {
    if ([12, 1, 2].includes(monthIndex)) { // Winter months
      recommendations = {
        countries: ['Thailand', 'Verenigde Arabische Emiraten', 'Egypte', 'Maldiven', 'Filipijnen', 'Vietnam', 'Indonesië', 'Sri Lanka'],
        regions: ['Phuket', 'Dubai', 'Abu Dhabi', 'Hurghada', 'Sharm el Sheikh', 'Bangkok', 'Ho Chi Minh Stad', 'Bali', 'Male', 'Colombo'],
        reason: 'Tropische winterescape',
        temperature: '22-30°C'
      };
      
      // Add Canary Islands only if Europe is not restricted
      if (!geographicRestrictions.includes('outside_europe') && !geographicRestrictions.includes('long_haul')) {
        recommendations.countries.push('Spanje');
        recommendations.regions.push('Tenerife', 'Gran Canaria', 'Lanzarote', 'Fuerteventura');
      }
    } else if ([3, 4, 5].includes(monthIndex)) { // Spring months
      recommendations = {
        countries: ['Egypte', 'Marokko', 'Jordanië', 'Verenigde Arabische Emiraten', 'Oman'],
        regions: ['Caïro', 'Marrakech', 'Dubai', 'Petra', 'Muscat'],
        reason: 'Perfecte lente temperaturen',
        temperature: '20-28°C'
      };
    } else if ([6, 7, 8].includes(monthIndex)) { // Summer months
      recommendations = {
        countries: ['Griekenland', 'Turkije', 'Spanje', 'Italië', 'Kroatië', 'Portugal', 'Cyprus', 'Malta'],
        regions: ['Santorini', 'Mykonos', 'Antalya', 'Costa Brava', 'Amalfikust', 'Dubrovnik', 'Algarve'],
        reason: 'Mediterrane zomer',
        temperature: '25-35°C'
      };
    } else { // Autumn months
      recommendations = {
        countries: ['Egypte', 'Jordanië', 'Marokko', 'Verenigde Arabische Emiraten', 'India'],
        regions: ['Luxor', 'Petra', 'Agadir', 'Dubai', 'Goa', 'Rajasthan'],
        reason: 'Warme herfstzon',
        temperature: '22-30°C'
      };
    }
  }
  
  // Apply geographic restrictions
  if (geographicRestrictions.includes('outside_europe')) {
    recommendations.countries = recommendations.countries.filter(country => !europeanCountries.includes(country));
    // Also filter regions that belong to European countries
    const europeanRegions = ['Tenerife', 'Gran Canaria', 'Lanzarote', 'Fuerteventura', 'Costa Brava', 'Costa del Sol', 'Santorini', 'Mykonos', 'Antalya', 'Amalfikust', 'Dubrovnik', 'Algarve'];
    recommendations.regions = recommendations.regions.filter(region => !europeanRegions.includes(region));
  } else if (geographicRestrictions.includes('europe_only')) {
    recommendations.countries = recommendations.countries.filter(country => europeanCountries.includes(country));
  }
  
  if (geographicRestrictions.includes('long_haul')) {
    const longHaulCountries = ['Thailand', 'Vietnam', 'Indonesië', 'Filipijnen', 'Maldiven', 'Sri Lanka', 'India', 'China', 'Japan'];
    recommendations.countries = recommendations.countries.filter(country => longHaulCountries.includes(country));
  }
  
  return recommendations;
};
